import Box from '@mui/material/Box';
import { DuplicateAccount } from './types/types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import ProgressChart from '../../../../features/common/ProgressChart';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import LeadDataFormater from '../../../../features/leads/view/LeadDataFormater';
import Button from '@mui/material/Button';
import StandardButton from '../../../components/Button/StandardButton';
import EditIcon from '@mui/icons-material/Edit';

type DuplicateAccountRowProps = {
    duplicate: DuplicateAccount;
    onAccountExists?: (account: DuplicateAccount) => void;
};

const DuplicateAccountRow = ({ onAccountExists, duplicate }: DuplicateAccountRowProps) => {
    const theme = useTheme();

    return (
        <Box sx={{ p: 3 }}>
            <Card sx={{ mb: 6 }} data-testid="activity-timeline" key={duplicate.id}>
                <CardContent sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                        <Grid xs={4}>
                            <ProgressChart
                                subHeading={duplicate.exactMatch ? 'Exact Match' : '% Match'}
                                seriesValue={duplicate.rank}
                                toolTip="Rank"
                            />
                            {/*{<Typography variant='h6'>*/}
                            {/*    Exact Match: {lead.exactMatch}*/}
                            {/*</Typography>*/}
                        </Grid>
                        <Grid
                            item
                            xs={4}
                            justifyContent={'center'}
                            alignItems={'center'}
                            sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                        >
                            <Grid
                                item
                                xs={12}
                                justifyContent={'center'}
                                alignItems={'center'}
                                sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                            >
                                <Typography variant="h6">{duplicate.name}</Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                justifyContent={'center'}
                                alignItems={'center'}
                                sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                            >
                                <LeadDataFormater
                                    labelText=""
                                    valueText={duplicate.industryName}
                                    textColor="CornflowerBlue"
                                    errorText="-Industry is missing-"
                                    chipHeight={20}
                                    chipFontSize="0.875rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />

                                <LeadDataFormater
                                    labelText="at"
                                    valueText={duplicate.hqRegionName}
                                    textColor="CornflowerBlue"
                                    errorText="-Region is missing-"
                                    chipHeight={20}
                                    chipFontSize="0.75rem"
                                    chipfontWeight={500}
                                    isChip={false}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            xs={4}
                            justifyContent={'center'}
                            alignItems={'center'}
                            sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                        >
                            <Grid
                                item
                                xs={12}
                                justifyContent={'center'}
                                alignItems={'center'}
                                sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {duplicate.hqCountryName != '' && (
                                            <Tooltip title="Country">
                                                <Typography variant="caption">{duplicate.hqCountryName}</Typography>
                                            </Tooltip>
                                        )}
                                        {duplicate.hqCountryName == '' && (
                                            <Tooltip title="Country">
                                                <Typography variant="caption">-Country Not Assigned-</Typography>
                                            </Tooltip>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>

                            {onAccountExists && (
                                <Grid
                                    item
                                    xs={12}
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <StandardButton
                                                onClick={() => onAccountExists(duplicate)}
                                                icon={<EditIcon />}
                                            >
                                                Edit Account
                                            </StandardButton>
                                        </Box>
                                    </Box>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default DuplicateAccountRow;
